export default __webpack_public_path__ + "static/foundation_b.54d1b9e8d91ab8a12b1c316bbc21ad4f.png";